<template>
  <transition name="fade">
    <div v-if="isOpen" class="modal-wrapper">
      <div class="modal-overlay" @click="closeModal" />
      <div class="modal-box">
        <div class="close-button" @click="closeModal" />
        <div class="modal-body">
          <slot name="icon"></slot>
          <h2 v-text="title" />
          <p v-if="text" v-text="text" />
          <slot name="extra"></slot>
        </div>
        <div
          v-if="buttons?.data?.length > 0"
          class="modal-footer"
          :class="{ column: buttons.column }"
        >
          <Button
            v-for="(btn, index) in buttons.data"
            :key="index"
            v-bind="btn"
            @click="emitCallbackBtn(index + 1)"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { watch } from "vue";

const emits = defineEmits(["callbackBtn1", "callbackBtn2", "close"]);

function emitCallbackBtn(index) {
  emits(`callbackBtn${index}`);
}

function closeModal() {
  emits("close");
}

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    required: true,
  },
  text: {
    type: String,
  },
  buttons: {
    type: Object,
    default() {
      return {
        column: false,
        data: [
          {
            label: "Continue",
            class: "primary",
          },
          {
            label: "Back",
            class: "outline",
          },
        ],
      };
    },
  },
});

watch(props, () => {
  if (props.isOpen) {
    document.querySelector("body").classList.add("noScroll");
  } else if (!props.isOpen) {
    document.querySelector("body").classList.remove("noScroll");
  }
});
</script>
